import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-ordem-producao-edit',
  templateUrl: './ordem-producao-edit.component.html',
  styleUrls: ['./ordem-producao-edit.component.css'],
  standalone: false
})
export class OrdemProducaoEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/ordens-producao`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Ordem de Produção', link: '/ordem-producao' }, { label: 'Edição Ordem de Produção' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'ordem-producao',
  };

  fields: PoPageDynamicEditField[] = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('ordemproducao').subscribe((data) => {
        this.fields = data;
    });
  }
}
